module.exports = __webpack_public_path__ + "img/Regatta_Professional-Logo.a3c14858.jpg";